import { Injectable } from "@angular/core";
import { map, Observable } from "rxjs";
import { GridService } from "../shared/grid/grid.service";
import { Shift } from "../models/shift.model";
import { HttpClient } from "@angular/common/http";
import nameOf from "../shared/form/nameOf.helper";

/**
 * A tenant's shift roster is small (a handful of patterns per org level), so a single
 * large page loads them all for the org-level Add-To-My-Site form.
 */
const ALL_SHIFTS_PAGE_SIZE = 1000;

@Injectable({
    providedIn: 'root'
})

export class ShiftService extends GridService<Shift> {

    constructor(http: HttpClient) {
        super('v1/Shift', http);
    }

    // GetAll returns id/name lookups only. When callers need the full shift entities
    // (e.g. to derive roster values such as shiftType/shiftLengthHours/averageWeeklyHours),
    // use the routed GetList grid endpoint and unwrap its data — the base GetAllEntities
    // action is NOT exposed as an HTTP route on CrudControllerBase (no [HttpGet]/[Route]), so
    // calling it would 404. GetList returns full ShiftDto records and runs through the same
    // secured (tenant-scoped) query, so only shifts within the caller's accessible org-level
    // hierarchy are returned; the empty filter returns all such shifts and the caller
    // (getShiftOptions) lists them without further client-side org-level filtering. Same
    // fetch-all-for-dropdown pattern as SegService.getMergeCandidates.
    getAllEntities(filterBy: string = ''): Observable<Shift[]> {
        return this.get('', nameOf<Shift>((x) => x.name), 'asc', 0, ALL_SHIFTS_PAGE_SIZE, filterBy).pipe(
            map((response) => response?.data ?? []),
        );
    }
}
